<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {

  },
  computed: {

  },
  data() {
    return {
      vm: {
        name: null,
        address: null,
        birthDate: null,
        age: null,
        gender: null,
        chronicDisease: [],
        bloodGroupId: null,
        phone: null,
        date: null,
        diseases:[],
        skinProblems:[]
      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("patients/edit", { id: this.itemId, payload: this.patient })
        .then(() => {
          this.back();
        })
        .catch(() => { });
        
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 2);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>